import { useEffect, useState } from "react";
import { _UBLInvoice } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

interface Props {
    idSelector: number;
    onChange: any;
    label: string;
}

export const SelectUBLDocumentPaymentType = ({ idSelector, label, onChange }: Props) => {

    const { instance, lista, setBean, setLista, bean } = useDataBean(_UBLInvoice)
    const [id, setID] = useState<number>(null);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e));
    }

    const getLista = () => {
        instance.getUBLDocumentPaymentTypeConstants(null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(e => { toast.error(e) })
    }
    return (
        <>
            <>
                <label>{label??"Tipos de pagos"}</label>
                <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                    <option value={null}>...</option>
                    {lista &&
                        lista.map((item: any) =>
                        (
                            <option key={item.DataBeanProperties.Value} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        ))
                    }
                </select>
            </>


        </>
    )
}
